import { takeEvery, fork, put, all, call } from 'redux-saga/effects';

import { customHeaders, adminAPIURL } from '../../../../../Containers/Config/index.js';
import { SAVE_COMMENTS, SAVE_COMMENTS_SUCCESS, SAVE_COMMENTS_ERROR } from '../../actions.js';
import apiCall from '../../../apiCall.js';
import cogoToast from 'cogo-toast';

function* saveComments({ payload }) {
  try {
    const filteredHeaders = { ...customHeaders };
    delete filteredHeaders['X-Requested-By'];

    // const { clientId, programId, userId } = payload?.data;

    const response = yield call(apiCall, {
      url: `${adminAPIURL}/v2/ticket-system/tickets/comments`,
      method: 'POST',
      data: payload?.data,
      headers: {
        // Authorization: Constant?.CLIENT_TOKEN,
        ...filteredHeaders,
        // withCredentials: true
      },
    });

    if (response.status === 200 || response.status === 201) {
      cogoToast.success(`${response?.data?.message}`);

      yield put({
        type: SAVE_COMMENTS_SUCCESS,
        payload: response?.data,
      });
    } else {
      cogoToast.error(`${response?.response?.data?.message}`);
      yield put({
        type: SAVE_COMMENTS_ERROR,
        payload: response.data.message,
      });
    }
  } catch (error) {
    yield put({ type: SAVE_COMMENTS_ERROR, payload: error });
  }
}

export function* watchsaveComments() {
  yield takeEvery(SAVE_COMMENTS, saveComments);
}

function* saveCommentsSaga() {
  yield all([fork(watchsaveComments)]);
}

export default saveCommentsSaga;
